import { createTheme as MuicreateTheme } from '@mui/material';
import { COLORS } from './colors';

/**
 * wrapped in a try catch as jest test is unable to compile
 */
const createTheme = () => {
  try {
    return MuicreateTheme({
      components: {
        MuiButtonBase: {
          defaultProps: {
            disableRipple: true,
          },
        },
        MuiDivider: {
          defaultProps: {
            sx: {
              bgcolor: 'rgba(145, 158, 171, 0.15)',
            },
          },
        },
        MuiSkeleton: {
          defaultProps: {
            animation: 'wave',
            sx: {
              bgcolor: 'rgba(145,158,171,0.3)',
              '&::after': {
                background: 'linear-gradient(90deg, transparent, rgba(145,158,171,0.25), transparent)',
              },
            },
          },
        },
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        MuiTimelineDot: {
          defaultProps: {
            sx: {
              bgcolor: COLORS.primaryDark,
              borderColor: COLORS.white,
              boxShadow: 'none',
            },
          },
        },
        MuiTimelineConnector: {
          defaultProps: {
            sx: {
              bgcolor: COLORS.grey1,
            },
          },
        },
      },
    });
  } catch {
    //
    return {};
  }
};

// required for material-ui to work
export const MUI_THEME = createTheme();
